import { render, staticRenderFns } from "./menuUserActions.vue?vue&type=template&id=254f37c2"
import script from "./menuUserActions.vue?vue&type=script&lang=js"
export * from "./menuUserActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports